import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type {
    IConfigurationGroup,
    IConfigurationGroupMonitoring,
    IResponseWithLoading,
    ISite,
} from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IModalService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services";
import { duration } from "moment-timezone";

export default class SiteConfigurationGroupMonitoringComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmModalService", "mmSitesRepository"];

    public configurationGroup: IConfigurationGroup;

    public configurationGroupMonitoring: IResponseWithLoading<IConfigurationGroupMonitoring>;

    public site: ISite;

    public timeUntilNotification: string;

    public deleted: (params: { id: string }) => void;

    constructor(
        private readonly $scope: IScope,
        private readonly modalService: IModalService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(
            this.sitesRepository.getConfigurationGroupMonitoring(
                this.configurationGroup.siteId,
                this.configurationGroup.id,
            ),
        )
            .pipe(
                finalize(() => {
                    this.$scope.$applyAsync();
                }),
            )
            .subscribe(
                (result) => {
                    if (result.data) {
                        this.setNotificationeTimeText(result.data);
                    }
                    this.configurationGroupMonitoring = result;
                },
                (error) => {
                    this.configurationGroupMonitoring = error;
                },
            );
    }

    public editConfiguration() {
        this.modalService
            .open<IConfigurationGroupMonitoring, void>(
                "mmConfigurationGroupMonitoringEdit",
                this.configurationGroupMonitoring.data,
                null,
                "lg",
            )
            .subscribe(
                (editedConfiguration) => {
                    if (editedConfiguration !== null) {
                        this.configurationGroupMonitoring.data = editedConfiguration;
                        this.configurationGroup.name = editedConfiguration.name;
                        this.setNotificationeTimeText(editedConfiguration);
                    } else {
                        this.deleted({ id: this.configurationGroup.id });
                    }
                },
                (reason) => reason,
            );
    }

    private setNotificationeTimeText(cfgm: IConfigurationGroupMonitoring): void {
        if (cfgm) {
            this.timeUntilNotification =
                duration(cfgm.timeUntilNotification).asSeconds() === 1
                    ? "Gui.Common.Immediate"
                    : duration(cfgm.timeUntilNotification).humanize();
        }
    }
}
